import { Channel, SessionInterface, UserInterface } from "@swivl-mono/types";
import { FC, useMemo } from "react";
import { IoIosGlobe } from "react-icons/io";
import { IoDocumentOutline } from "react-icons/io5";
import { Link } from "react-router-dom";

import { useUrlState } from "../../Hooks/useUrlState";

interface UserDetailsSectionProps {
  sessions: SessionInterface[] | null;
  user: UserInterface;
}

const UserDetailsSection: FC<UserDetailsSectionProps> = ({ sessions, user }) => {
  const { searchParams } = useUrlState();
  const currentChannel = searchParams.get("channel");

  const { websessionHost, websessionPath, websessionHref } = useMemo(() => {
    if (sessions) {
      const webSessions = sessions?.filter((session) => session.channel === Channel.WEB) || [];
      const mostRecentWebSession = webSessions.length
        ? webSessions.sort((a, b) => (b?.updatedAt ? Number(b.updatedAt) : 0) - (a?.updatedAt ? Number(a.updatedAt) : 0))[0]
        : null;
      if (mostRecentWebSession && mostRecentWebSession.url) {
        const url = new URL(mostRecentWebSession.url);
        return {
          websessionHost: url.host,
          websessionPath: url.pathname || "",
          websessionHref: url.href
        };
      }
    }
    return {
      websessionHost: undefined,
      websessionPath: undefined,
      websessionHref: undefined
    };
  }, [sessions]);

  // const websessionHost = mostRecentWebSessionUrl?.host;
  // const websessionPath = mostRecentWebSessionUrl?.pathname || "";

  return (
    <div className="grid grid-cols-2 gap-1 text-sm">
      <div className="flex flex-col">
        <h3 className="text-grey-600">First Interaction</h3>
        <span>{user?.createdAt?.toLocaleDateString() || "--"}</span>
      </div>

      <div className="flex flex-col">
        <h3 className="text-grey-600">Last Interaction</h3>
        <span>{user?.lastInteractionAt?.toLocaleDateString() || "--"}</span>
      </div>
      {currentChannel === Channel.WEB && (
        <>
          {/* most recent web session url host */}
          {websessionHost && (
            <div className="col-span-2 flex items-center gap-1">
              <IoIosGlobe className="text-grey-600" />
              <span>{websessionHost || "--"}</span>
            </div>
          )}

          {/* most recent web session url path */}
          {websessionHost && (
            <div className="col-span-2 flex items-center gap-1">
              <IoDocumentOutline />
              <Link className="underline transition-colors duration-200 ease-in-out hover:text-orange-500" to={websessionHref || "#"}>
                {websessionPath?.length > 1 ? websessionPath : "homepage"}
              </Link>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default UserDetailsSection;
